import React, { useState } from 'react';
import './CustomDropdown.css'; // Import your CSS file for styling

interface CustomDropdownProps {
    options: string[];
    onSelect: (option: string) => void;
}

const CustomDropdown: React.FC<CustomDropdownProps> = ({ options, onSelect }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [selectedOption, setSelectedOption] = useState<string | null>(null);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleOptionClick = (option: string) => {
        setSelectedOption(option);
        onSelect(option);
        toggleDropdown();
    };

    return (
        <div className="custom-dropdown">
            <div className="selected-option" onClick={toggleDropdown}>
                {selectedOption?.slice(0,160) || 'Select an option'}
                <span className={`arrow ${isOpen ? 'open' : ''}`}>&#9660;</span>
            </div>
            {isOpen && (
                <ul className="options">
                    {options.map((option, index) => (
                        <li key={index} onClick={() => handleOptionClick(option)}>
                            {option}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default CustomDropdown;
